import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AppSubMenu, MenuComponent} from './menu/menu.component';
import {NavComponent} from './nav/nav.component';
import {HomeComponent} from './home.component';
import {FormsModule} from '@angular/forms';
import {HomeRoutingModule} from './routing.module';
import {BrowserModule} from '@angular/platform-browser';
import {CheckboxModule} from 'primeng/components/checkbox/checkbox';
import {ChartModule} from 'primeng/components/chart/chart';
import {CarouselModule} from 'primeng/components/carousel/carousel';
import {CalendarModule} from 'primeng/components/calendar/calendar';
import {ChipsModule} from 'primeng/components/chips/chips';
import {ButtonModule} from 'primeng/components/button/button';
import {BreadcrumbModule} from 'primeng/components/breadcrumb/breadcrumb';
import {AutoCompleteModule} from 'primeng/components/autocomplete/autocomplete';
import {AccordionModule} from 'primeng/components/accordion/accordion';
import {CodeHighlighterModule} from 'primeng/components/codehighlighter/codehighlighter';
import {ConfirmDialogModule} from 'primeng/components/confirmdialog/confirmdialog';
import {SharedModule} from 'primeng/components/common/shared';
import {ContextMenuModule} from 'primeng/components/contextmenu/contextmenu';
import {DataGridModule} from 'primeng/components/datagrid/datagrid';
import {DataListModule} from 'primeng/components/datalist/datalist';
import {DataScrollerModule} from 'primeng/components/datascroller/datascroller';
import {DataTableModule} from 'primeng/components/datatable/datatable';
import {DialogModule} from 'primeng/components/dialog/dialog';
import {DragDropModule} from 'primeng/components/dragdrop/dragdrop';
import {DropdownModule} from 'primeng/components/dropdown/dropdown';
import {EditorModule} from 'primeng/components/editor/editor';
import {FieldsetModule} from 'primeng/components/fieldset/fieldset';
import {PasswordModule} from 'primeng/components/password/password';
import {PanelMenuModule} from 'primeng/components/panelmenu/panelmenu';
import {PanelModule} from 'primeng/components/panel/panel';
import {PaginatorModule} from 'primeng/components/paginator/paginator';
import {OverlayPanelModule} from 'primeng/components/overlaypanel/overlaypanel';
import {OrderListModule} from 'primeng/components/orderlist/orderlist';
import {MultiSelectModule} from 'primeng/components/multiselect/multiselect';
import {MessagesModule} from 'primeng/components/messages/messages';
import {PickListModule} from 'primeng/components/picklist/picklist';
import {MenubarModule} from 'primeng/components/menubar/menubar';
import {MenuModule} from 'primeng/components/menu/menu';
import {MegaMenuModule} from 'primeng/components/megamenu/megamenu';
import {ListboxModule} from 'primeng/components/listbox/listbox';
import {LightboxModule} from 'primeng/components/lightbox/lightbox';
import {InputTextareaModule} from 'primeng/components/inputtextarea/inputtextarea';
import {InputTextModule} from 'primeng/components/inputtext/inputtext';
import {InputSwitchModule} from 'primeng/components/inputswitch/inputswitch';
import {InputMaskModule} from 'primeng/components/inputmask/inputmask';
import {GMapModule} from 'primeng/components/gmap/gmap';
import {GalleriaModule} from 'primeng/components/galleria/galleria';
import {FileUploadModule} from 'primeng/components/fileupload/fileupload';
import {ProgressBarModule} from 'primeng/components/progressbar/progressbar';
import {RadioButtonModule} from 'primeng/components/radiobutton/radiobutton';
import {RatingModule} from 'primeng/components/rating/rating';
import {ScheduleModule} from 'primeng/components/schedule/schedule';
import {SelectButtonModule} from 'primeng/components/selectbutton/selectbutton';
import {TerminalModule} from 'primeng/components/terminal/terminal';
import {TabViewModule} from 'primeng/components/tabview/tabview';
import {TabMenuModule} from 'primeng/components/tabmenu/tabmenu';
import {StepsModule} from 'primeng/components/steps/steps';
import {SplitButtonModule} from 'primeng/components/splitbutton/splitbutton';
import {SpinnerModule} from 'primeng/components/spinner/spinner';
import {SliderModule} from 'primeng/components/slider/slider';
import {SlideMenuModule} from 'primeng/components/slidemenu/slidemenu';
import {TieredMenuModule} from 'primeng/components/tieredmenu/tieredmenu';
import {ToggleButtonModule} from 'primeng/components/togglebutton/togglebutton';
import {ToolbarModule} from 'primeng/components/toolbar/toolbar';
import {TooltipModule} from 'primeng/components/tooltip/tooltip';
import {InlineProfileComponent} from './inline-profile/inline-profile.component';
import {AdminModule} from '../admin/admin.module';
import {GlobalAppService} from '../core/commons/global-app.service';
import {PersonalConfigModule} from '../personal-config/personal-config.module';
import {FXDirectiveModule} from '../directives/fx.directive';
import {ProfileModule} from '../profile/profile.module';
import {ConfigService} from '../personal-config/config.service';
import {FiscaliaModule} from '../fiscalia/fiscalia.module';
import {DynFormsModule} from '../forms/dyn-forms.module';
import {MatPaginatorIntl} from '@angular/material/paginator';

import {ProfileStoreService} from 'app/profile/service/profile-store.service';
import {ProfileService} from 'app/profile/service/profile.service';
import {MessagingService} from 'app/home/service/messaging.service';
import {MatCardModule} from '@angular/material/card';
import {MatRippleModule} from '@angular/material/core';
import {MatButtonModule} from '@angular/material/button';
import {ScrollDispatchModule} from '@angular/cdk/scrolling';
import {NotificationTopicService} from './service/notificationTopic.service';
import {PageStateService} from '../core/service/page-state.service';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        HomeRoutingModule,
        AdminModule,
        BrowserModule,
        // HttpModule,
        AccordionModule,
        AutoCompleteModule,
        BreadcrumbModule,
        ButtonModule,
        CalendarModule,
        CarouselModule,
        ChartModule,
        ChipsModule,
        CheckboxModule,
        CodeHighlighterModule,
        ConfirmDialogModule,
        SharedModule,
        DataGridModule,
        ContextMenuModule,
        DataListModule,
        DataScrollerModule,
        DataTableModule,
        DialogModule,
        DragDropModule,
        DropdownModule,
        EditorModule,
        FieldsetModule,
        FileUploadModule,
        GalleriaModule,
        GMapModule,
        InputMaskModule,
        InputSwitchModule,
        InputTextModule,
        InputTextareaModule,
        LightboxModule,
        ListboxModule,
        MegaMenuModule,
        MenuModule,
        MenubarModule,
        MessagesModule,
        MultiSelectModule,
        OrderListModule,
        OverlayPanelModule,
        PaginatorModule,
        PanelModule,
        PanelMenuModule,
        PasswordModule,
        PickListModule,
        ProgressBarModule,
        RadioButtonModule,
        RatingModule,
        ScheduleModule,
        SelectButtonModule,
        SlideMenuModule,
        SliderModule,
        SpinnerModule,
        SplitButtonModule,
        StepsModule,
        TabMenuModule,
        TabViewModule,
        TerminalModule,
        TieredMenuModule,
        ToggleButtonModule,
        ToolbarModule,
        TooltipModule,
        FiscaliaModule,
        PersonalConfigModule,
        FXDirectiveModule,
        ProfileModule,
        DynFormsModule,
        MatCardModule,
        MatRippleModule,
        MatButtonModule,
        ScrollDispatchModule
    ],
    declarations: [
        MenuComponent,
        NavComponent,
        HomeComponent,
        AppSubMenu,
        InlineProfileComponent
    ],
    providers: [
        GlobalAppService,
        ConfigService,
        MatPaginatorIntl,
        ProfileService,
        MessagingService,
        NotificationTopicService,
        PageStateService
    ]
})
export class HomeModule {
}



// WEBPACK FOOTER //
// ./src/app/home/home.module.ts